export default __webpack_public_path__ + "static/media/screen5.788bd06a.svg";